export default __webpack_public_path__ + "static/blog-post-5-b96b06f9397b6a3b2ecd3bdb73ce04a2.png";